import { User } from 'types';

export const formatPageTitle = (data): string =>
  `${data.title} by ${getDisplayName(data.artist)}`;

const getDisplayName = (artist: User) =>
  artist.artistName || `${artist.firstName} ${artist.lastName}`;
